import {
  writeAttachmentLocale,
  type AttachmentLocale,
} from '../../../../../shared/localization.ts';

/** Browser attachment identity and language share the existing socket handshake. */
export function buildSessionWsUrl(params: {
  baseUrl: string;
  path: '/ws' | '/voice';
  agentSessionId: string | null;
  locale?: AttachmentLocale;
  phoneSimulation?: boolean;
  voiceTransport?: 'webrtc';
  voiceConnectionId?: string;
}): string {
  const url = new URL(params.path, params.baseUrl);
  if (url.protocol === 'https:') {
    url.protocol = 'wss:';
  }
  if (url.protocol === 'http:') {
    url.protocol = 'ws:';
  }
  if (params.path === '/voice' && params.phoneSimulation) {
    url.searchParams.set('phone_sim', '1');
  } else {
    if (params.agentSessionId) {
      url.searchParams.set('agent_session_id', params.agentSessionId);
    }
    writeAttachmentLocale(url.searchParams, params.locale);
  }
  if (params.path === '/voice' && !params.phoneSimulation && params.voiceTransport)
    url.searchParams.set('transport', params.voiceTransport);
  if (params.path === '/voice' && !params.phoneSimulation && params.voiceConnectionId)
    url.searchParams.set('voiceConnectionId', params.voiceConnectionId);
  return url.toString();
}

/**
 * Check if running in local/preview dev environment
 */
export const isDevEnvironment = () => {
  return location.hostname === 'localhost' || location.hostname.includes('preview');
};

/**
 * Get the base URL for API requests.
 * Uses relative URL since client is served by the same server that handles API.
 */
export const getApiBaseUrl = () => {
  return '/api';
};

/**
 * Get the base URL for WebSocket connections (without /api path).
 * Uses current origin since client is served by the same server.
 */
export const getWsBaseUrl = () => {
  const wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProtocol}//${location.host}`;
};
